import { useLocation, useNavigate } from "react-router-dom";

const NavBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <div className="headerMenu basis-1/3 items-center lg:h-full fixed left-0 bottom-0 right-0 h-toolbar bg-white dark:bg-[#012359] lg:bg-transparent shadow-menufooter dark:shadow-headerMenuDarkTheme lg:dark:shadow-none lg:static lg:shadow-none">
      <div className="flex items-center justify-center max-[430px]:gap-2 gap-4 lg:gap-7 h-full">
        {/* Dashboard */}
        <div
          data-testid="nav-dashboard"
          className={`flex flex-col gap-1 justify-center items-center cursor-pointer basis-12 sm:basis-16 shrink-0 h-full ${location?.pathname.startsWith("/dashboard")
              ? "border-theme border-b-2 active"
              : "border-dark-grey"
            }`}
          onClick={() => navigate("/dashboard")}
        >
          <div className="iconHolder">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
            >
              <path
                d="M20.0334 15.5524C18.8597 19.2893 15.3686 22 11.2443 22C6.15728 22 2.03345 17.8762 2.03345 12.7892C2.03345 8.66488 4.7441 5.1737 8.48103 4"
                stroke={
                  location?.pathname.startsWith("/dashboard")
                    ? "#FF8C65"
                    : (document.documentElement.classList.contains("dark")
                          ? "#FFFFFF" // Dark mode, not dashboard
                          : "#1E2A2C") // Light mode, not dashboard
                  }
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M21.9465 9.94727C20.885 6.14438 17.8891 3.14845 14.0862 2.0869C12.4426 1.6281 11.0334 3.05419 11.0334 4.76062V11.4551C11.0334 12.3083 11.7251 13 12.5783 13H19.2728C20.9793 13 22.4053 11.5909 21.9465 9.94727Z"
                stroke={
                  location?.pathname.startsWith("/dashboard")
                    ? "#FF8C65"
                    : (document.documentElement.classList.contains("dark")
                ? "#FFFFFF" // Dark mode, not dashboard
                : "#1E2A2C") // Light mode, not dashboard
        }
                strokeWidth="1.5"
              />
            </svg>
          </div>
          <div
            className={` text-xs leading-5 font-medium tracking-[0.024px] ${location?.pathname.startsWith("/dashboard")
                ? "text-theme"
                : "text-dark-grey dark:text-white"
              }`}
          >
            Dashboard
          </div>
        </div>

        {/* Units */}

        <div
          data-testid="nav-units"
          className={`flex flex-col gap-1 justify-center items-center cursor-pointer basis-16 shrink-0  h-full relative  ${location?.pathname.startsWith("/units")
              ? "border-theme border-b-2 active"
              : "border-dark-grey"
            }`}
          onClick={() => navigate("/units")}
        >
          <div className="iconHolder">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
            >
              <path
                d="M13.5334 15.5C13.5334 13.6144 13.5334 12.6716 14.1192 12.0858C14.705 11.5 15.6478 11.5 17.5334 11.5C19.4191 11.5 20.3619 11.5 20.9477 12.0858C21.5334 12.6716 21.5334 13.6144 21.5334 15.5V17.5C21.5334 19.3856 21.5334 20.3284 20.9477 20.9142C20.3619 21.5 19.4191 21.5 17.5334 21.5C15.6478 21.5 14.705 21.5 14.1192 20.9142C13.5334 20.3284 13.5334 19.3856 13.5334 17.5V15.5Z"
                stroke={
                  location?.pathname.startsWith("/units")
                    ? "#FF8C65"
                    : (document.documentElement.classList.contains("dark")
          ? "#FFFFFF" // Dark mode, not dashboard
          : "#1E2A2C") // Light mode, not dashboard
  }
                strokeWidth="1.5"
              />
              <path
                d="M2.03345 8.5C2.03345 10.3856 2.03345 11.3284 2.61923 11.9142C3.20502 12.5 4.14783 12.5 6.03345 12.5C7.91907 12.5 8.86187 12.5 9.44766 11.9142C10.0334 11.3284 10.0334 10.3856 10.0334 8.5V6.5C10.0334 4.61438 10.0334 3.67157 9.44766 3.08579C8.86187 2.5 7.91907 2.5 6.03345 2.5C4.14783 2.5 3.20502 2.5 2.61923 3.08579C2.03345 3.67157 2.03345 4.61438 2.03345 6.5V8.5Z"
                stroke={
                  location?.pathname.startsWith("/units")
                    ? "#FF8C65"
                    : (document.documentElement.classList.contains("dark")
          ? "#FFFFFF" // Dark mode, not dashboard
          : "#1E2A2C") // Light mode, not dashboard
  }
                strokeWidth="1.5"
              />
              <path
                d="M13.5334 5.5C13.5334 4.56812 13.5334 4.10218 13.6857 3.73463C13.8887 3.24458 14.278 2.85523 14.7681 2.65224C15.1356 2.5 15.6016 2.5 16.5334 2.5H18.5334C19.4653 2.5 19.9313 2.5 20.2988 2.65224C20.7889 2.85523 21.1782 3.24458 21.3812 3.73463C21.5334 4.10218 21.5334 4.56812 21.5334 5.5C21.5334 6.43188 21.5334 6.89782 21.3812 7.26537C21.1782 7.75542 20.7889 8.14477 20.2988 8.34776C19.9313 8.5 19.4653 8.5 18.5334 8.5H16.5334C15.6016 8.5 15.1356 8.5 14.7681 8.34776C14.278 8.14477 13.8887 7.75542 13.6857 7.26537C13.5334 6.89782 13.5334 6.43188 13.5334 5.5Z"
                stroke={
                  location?.pathname.startsWith("/units")
                    ? "#FF8C65"
                    : (document.documentElement.classList.contains("dark")
          ? "#FFFFFF" // Dark mode, not dashboard
          : "#1E2A2C") // Light mode, not dashboard
  }
                strokeWidth="1.5"
              />
              <path
                d="M2.03345 18.5C2.03345 19.4319 2.03345 19.8978 2.18569 20.2654C2.38868 20.7554 2.77802 21.1448 3.26808 21.3478C3.63562 21.5 4.10156 21.5 5.03345 21.5H7.03345C7.96533 21.5 8.43127 21.5 8.79881 21.3478C9.28887 21.1448 9.67822 20.7554 9.88121 20.2654C10.0334 19.8978 10.0334 19.4319 10.0334 18.5C10.0334 17.5681 10.0334 17.1022 9.88121 16.7346C9.67822 16.2446 9.28887 15.8552 8.79881 15.6522C8.43127 15.5 7.96533 15.5 7.03345 15.5H5.03345C4.10156 15.5 3.63562 15.5 3.26808 15.6522C2.77802 15.8552 2.38868 16.2446 2.18569 16.7346C2.03345 17.1022 2.03345 17.5681 2.03345 18.5Z"
                stroke={
                  location?.pathname.startsWith("/units")
                    ? "#FF8C65"
                    : (document.documentElement.classList.contains("dark")
          ? "#FFFFFF" // Dark mode, not dashboard
          : "#1E2A2C") // Light mode, not dashboard
  }
                strokeWidth="1.5"
              />
            </svg>
          </div>
          <div
            className={` text-xs leading-5 font-medium tracking-[0.024px]  ${location?.pathname.startsWith("/units")
                ? "text-theme"
                : "text-dark-grey dark:text-white"
              }`}
          >
            Units
          </div>
        </div>

        {/* Usage */}
        <div
          data-testid="nav-energy"
          className={`flex flex-col gap-0 justify-center items-center cursor-pointer basis-16 shrink-0 h-full ${location?.pathname.startsWith("/energy")
            ? "border-theme border-b-2 active"
            : "border-dark-grey"
          } `} onClick={() => navigate("/energy")}>
          <div className="iconHolder -mb-[4px]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="36"
              height="36"
              viewBox="0 0 64 64"
              fill="none">
              <path
                d="M35 10L22 34H31L28 54L42 28H33L35 10Z"
                stroke={
                  location?.pathname.startsWith("/energy")
                    ? "#FF8C65"
                    : (document.documentElement.classList.contains("dark")
          ? "#FFFFFF" // Dark mode, not dashboard
          : "#1E2A2C") // Light mode, not dashboard
  }
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round" />
            </svg>
          </div>
          <div className={`relative -top-[2px] text-center text-xs leading-5 font-medium tracking-[0.024px] ${location?.pathname.startsWith("/energy")
              ? "text-theme"
              : "text-dark-grey dark:text-white"
            }`} >
            Energy
          </div>
        </div>

        {/* Alarms */}
        <div
          data-testid="nav-alerts"
          className={`flex flex-col gap-1 justify-center items-center cursor-pointer basis-16 shrink-0 h-full ${location?.pathname.startsWith("/alerts")
            ? "border-theme border-b-2 active"
            : "border-dark-grey"
          }`} onClick={() => navigate("/alerts")}>
          <div className="iconHolder">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
            >
              <path
                d="M12.0334 7V13"
                stroke={
                  location?.pathname.startsWith("/alerts")
                    ? "#FF8C65"
                    : (document.documentElement.classList.contains("dark")
          ? "#FFFFFF" // Dark mode, not dashboard
          : "#1E2A2C") // Light mode, not dashboard
  }
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <circle
                cx="12.0334"
                cy="16"
                r="0.5"
                fill="white"
                stroke={
                  location?.pathname.startsWith("/alerts")
                    ? "#FF8C65"
                    : (document.documentElement.classList.contains("dark")
          ? "#FFFFFF" // Dark mode, not dashboard
          : "#1E2A2C") // Light mode, not dashboard
  }
              />
              <path
                d="M7.87653 3.80211C9.90524 2.6007 10.9196 2 12.0334 2C13.1473 2 14.1616 2.6007 16.1904 3.80211L16.8765 4.20846C18.9052 5.40987 19.9196 6.01057 20.4765 7C21.0334 7.98943 21.0334 9.19084 21.0334 11.5937V12.4063C21.0334 14.8092 21.0334 16.0106 20.4765 17C19.9196 17.9894 18.9052 18.5901 16.8765 19.7915L16.1904 20.1979C14.1616 21.3993 13.1473 22 12.0334 22C10.9196 22 9.90524 21.3993 7.87653 20.1979L7.19037 19.7915C5.16165 18.5901 4.14729 17.9894 3.59037 17C3.03345 16.0106 3.03345 14.8092 3.03345 12.4063V11.5937C3.03345 9.19084 3.03345 7.98943 3.59037 7C4.14729 6.01057 5.16165 5.40987 7.19037 4.20846L7.87653 3.80211Z"
                stroke={
                  location?.pathname.startsWith("/alerts")
                    ? "#FF8C65"
                    : (document.documentElement.classList.contains("dark")
          ? "#FFFFFF" // Dark mode, not dashboard
          : "#1E2A2C") // Light mode, not dashboard
  }
                strokeWidth="1.5"
              />
            </svg>
          </div>
          <div
            className={` text-xs leading-5 font-medium tracking-[0.024px]  ${location?.pathname.startsWith("/alerts")
                ? "text-theme"
                : "text-dark-grey dark:text-white"
              }`}
          >
            Alerts
          </div>
        </div>

        {/* Control */}
        <div
          data-testid="nav-control"
          className={`flex flex-col gap-1 justify-center items-center cursor-pointer basis-16 shrink-0 h-full ${location?.pathname.startsWith("/control")
            ? "border-theme border-b-2 active"
            : "border-dark-grey"
          }`} onClick={() => navigate("/control")}>
          <div className="iconHolder">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
            >
              <path
                d="M10.0335 9.5C10.0335 11.1569 8.69033 12.5 7.03347 12.5C5.37662 12.5 4.03347 11.1569 4.03347 9.5C4.03347 7.84315 5.37662 6.5 7.03347 6.5C8.69033 6.5 10.0335 7.84315 10.0335 9.5Z"
                stroke={
                  location?.pathname.startsWith("/control")
                    ? "#FF8C65"
                    : (document.documentElement.classList.contains("dark")
          ? "#FFFFFF" // Dark mode, not dashboard
          : "#1E2A2C") // Light mode, not dashboard
  }
                strokeWidth="1.5"
              />
              <path
                d="M20.0335 14.5C20.0335 12.8431 18.6903 11.5 17.0335 11.5C15.3766 11.5 14.0335 12.8431 14.0335 14.5C14.0335 16.1569 15.3766 17.5 17.0335 17.5C18.6903 17.5 20.0335 16.1569 20.0335 14.5Z"
                stroke={
                  location?.pathname.startsWith("/control")
                    ? "#FF8C65"
                    : (document.documentElement.classList.contains("dark")
          ? "#FFFFFF" // Dark mode, not dashboard
          : "#1E2A2C") // Light mode, not dashboard
  }
                strokeWidth="1.5"
              />
              <path
                d="M7.07495 15V22"
                stroke={
                  location?.pathname.startsWith("/control")
                    ? "#FF8C65"
                    : (document.documentElement.classList.contains("dark")
          ? "#FFFFFF" // Dark mode, not dashboard
          : "#1E2A2C") // Light mode, not dashboard
  }
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M17.075 9L17.075 2"
                stroke={
                  location?.pathname.startsWith("/control")
                    ? "#FF8C65"
                    : (document.documentElement.classList.contains("dark")
          ? "#FFFFFF" // Dark mode, not dashboard
          : "#1E2A2C") // Light mode, not dashboard
  }
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M7.07495 2V4"
                stroke={
                  location?.pathname.startsWith("/control")
                    ? "#FF8C65"
                    : (document.documentElement.classList.contains("dark")
          ? "#FFFFFF" // Dark mode, not dashboard
          : "#1E2A2C") // Light mode, not dashboard
  }
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M17.075 22L17.075 20"
                stroke={
                  location?.pathname.startsWith("/control")
                    ? "#FF8C65"
                    : (document.documentElement.classList.contains("dark")
          ? "#FFFFFF" // Dark mode, not dashboard
          : "#1E2A2C") // Light mode, not dashboard
  }
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
          </div>
          <div className={` text-xs leading-5 font-medium tracking-[0.024px]  ${location?.pathname.startsWith("/control")
              ? "text-theme"
              : "text-dark-grey dark:text-white"
            }`}>
            Control
          </div>
        </div>
      </div>
    </div>
  );
}

export default NavBar;
